import type { EmbedOptions } from '~/playerEmbedOptions/types';
import { isEmbedOptions } from '~/playerEmbedOptions/types';
import { cast, clone } from '~/utilities/obj';

export const cleanPlayerEmbedOptions = (rawEmbedOptions: Record<string, unknown>): EmbedOptions => {
  // cast isn't typed, but the gist is it converts stringy numbers and booleans to actual numbers and booleans
  const embedOptions = cast(clone(rawEmbedOptions)) as unknown;

  if (!isEmbedOptions(embedOptions)) {
    throw new Error('embedOptions is invalid');
  }

  // The player color is a hex code string, but if that hex code is all numbers,
  // it'll get casted to a number. Make sure it stays a string.
  embedOptions.playerColor = embedOptions.playerColor.toString();

  // Handle gradient colors if they exist
  if (embedOptions.playerColorGradient?.colors) {
    embedOptions.playerColorGradient.colors = embedOptions.playerColorGradient.colors.map(
      // gradientColorAndPercentage is supposed to be a tuple, but it's actually
      // an object with keys 0 and 1. So we can't use array destructuring here.
      (gradientColorAndPercentage) => [
        gradientColorAndPercentage[0].toString(),
        gradientColorAndPercentage[1],
      ],
    );
  }

  return embedOptions;
};
